import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-slide",
  "use": "icon-slide-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" fill=\"currentColor\" aria-hidden=\"true\" class=\"SlidingCaptcha_slider-mask-item-icon__yszwZ\" id=\"icon-slide\"><path d=\"m873.1 596.2-164-208A32 32 0 0 0 684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol